import Handsontable from "handsontable";
import isEqual from "lodash.isequal";

export const defaultSettings = {
  data: [],
  dataSchema: {},
  columns: [],
  colHeaders: {},
  columnSorting: true,
  manualColumnResize: true,
  readOnly: true,
  observeChanges: true,
  rowHeaders: true,
  autoWrapRow: false,
  autoRowSize: false,
  outsideClickDeselects: false,
  stretchH: "all",
  selectionMode: "range"
};

export const menu = state => {
  return {
    items: {
      add_row: {
        name: "Добавить новый объект",
        hidden: function() {
          if (!state.hasEditor) return true;
        },
        callback: function() {
          state.createNewObject();
        }
      },
      separator1: Handsontable.plugins.ContextMenu.SEPARATOR,
      alignment: {},
      separator2: Handsontable.plugins.ContextMenu.SEPARATOR,
      cut: {
        name: "<div>Вырезать </div><div class='htItemWrapper--sub'>Ctrl+X</div>"
      },
      copy: {
        name:
          "<div>Копировать </div><div class='htItemWrapper--sub'>Ctrl+C</div>"
      },
      separator3: Handsontable.plugins.ContextMenu.SEPARATOR,
      delete_object: {
        name: "Удалить выделенный объект(ы)",
        hidden: function() {
          if (!state.hasEditor) return true;
        },
        callback: function(key, selection) {
          let selectedRowIds = [];

          for (let i = selection[0].start.row; i <= selection[0].end.row; i++) {
            selectedRowIds.push(state.myInstance.getDataAtRowProp(i, "id"));
          }
          state.beforeDeleteObjects(selectedRowIds);
        }
      },
      separator4: Handsontable.plugins.ContextMenu.SEPARATOR,
      undo: {
        name:
          "<div>Отменить изменения </div><div class='htItemWrapper--sub'>Ctrl+Z</div>"
      },
      redo: {
        name:
          "<div>Вернуть изменения </div><div class='htItemWrapper--sub'>Shift+Ctrl+Z</div>"
      },
      changes_cancel: {
        name: "Отменить все изменения",
        hidden: function() {
          if (!state.hasEditor || !state.hasChanges) return true;
        },
        callback: function() {
          state.beforeCancelChanges();
        }
      },
      separator5: Handsontable.plugins.ContextMenu.SEPARATOR,
      openObjectInfo: {
        name: "Информация об объекте",
        hidden: function() {
          let selected = this.getSelectedRangeLast();
          return !isEqual(selected.from, selected.to);
        },
        callback: function(key, selection) {
          state.openObjectInfo(selection);
        }
      }
    }
  };
};

export const beforeColumnSort = state => {
  return function(currentSortConfig, destinationSortConfigs) {
    const columnSortPlugin = state.myInstance.getPlugin("columnSorting");
    columnSortPlugin.setSortConfig(destinationSortConfigs);
    let currentColumn;
    let sortOrder;

    if (!state.$store.state.book.activeTable.full) {
      currentColumn = destinationSortConfigs[0]
        ? destinationSortConfigs[0].column
        : currentSortConfig[0].column;
      sortOrder = destinationSortConfigs[0]
        ? destinationSortConfigs[0].sortOrder
        : null;

      const attr = state.settings.columns[currentColumn].data;
      state.$store.commit("SET_TABLE_SORT_CONFIG", { attr, sortOrder });
      return false;
    } else {
      return true;
    }
  };
};

export const afterColumnSort = state => {
  return () => state.selectRowById(state.activeObjectInfo, true);
};

export const afterChange = state => {
  return function(changes) {
    if (changes) {
      changes.forEach(([row, prop, oldValue, newValue]) => {
        state.observeRowChanges(row, prop, oldValue, newValue);
      });
      state.tableRerender();
    }
  };
};

export const afterViewportRowCalc = state => {
  return function(val) {
    if (state.$store.state.book.activeTable.full) return;
    const dataLimit = state.$store.state.book.activeTable.limit;
    if (dataLimit - 1 === val.endRow) {
      state.$store.commit("SHOW_DATA_INCREASE_BUTTON", true);
    } else {
      state.$store.commit("SHOW_DATA_INCREASE_BUTTON", false);
    }
  };
};

export const colHeaders = (state, tableHead) => {
  return function(col) {
    return tableHead[col];
  };
};

export const afterSelectionEnd = state => {
  return function(row, col, row2) {
    state.selectedRowsAmount = row === row2 ? 1 : 2;
  };
};

export const afterDeselect = state => {
  return function() {
    state.selectedRowsAmount = 0;
  };
};

// customColumnsRendeder - START
function isChanged(state, row, prop) {
  let currentRowId;
  let currentRow;

  if (state.myInstance)
    currentRowId = state.myInstance.getDataAtRowProp(row, "id");
  if (state.changedRows[currentRowId]) {
    currentRow = state.changedRows[currentRowId];
    if (currentRow[prop] !== undefined) return true;
  }

  return false;
}

const customRenderer = (state, type = null) => {
  return function(instance, td, row, col, prop, value, cellProp) {
    if (state.activeObjectRow === row) td.classList.add("activeObject");
    switch (type) {
      case "numeric":
        Handsontable.renderers.NumericRenderer.apply(this, arguments);
        if (cellProp.valid) {
          if (isChanged(state, row, prop)) td.classList.add("changed");
        }
        break;
      case "date":
        Handsontable.renderers.DateRenderer.apply(this, arguments);
        if (cellProp.valid) {
          if (isChanged(state, row, prop)) td.classList.add("changed");
        }
        break;
      default:
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        if (isChanged(state, row, prop)) td.classList.add("changed");
        break;
    }
  };
};

export const columnsRenderer = (state, activeFields) => {
  let tableColumns = [
    { data: "id", readOnly: true, renderer: customRenderer(state) }
  ];

  activeFields.forEach(e => {
    let columns = {};
    switch (e.type) {
      case "integer":
        columns = {
          data: e.title,
          type: "numeric",
          numericFormat: {
            pattern: "0,0.00",
            culture: "ru-RU"
          },
          renderer: customRenderer(state, "numeric")
        };
        break;
      case "decimal":
      case "numeric":
      case "float":
      case "number":
        columns = {
          data: e.title,
          type: "numeric",
          numericFormat: {
            pattern: "0,0.00",
            culture: "ru-RU"
          },
          renderer: customRenderer(state, "numeric")
        };
        break;
      case "datetime":
      case "date":
      case "time":
        if (!e.read_only) {
          columns = {
            data: e.title,
            type: "date",
            dateFormat: "DD/MM/YYYY",
            renderer: customRenderer(state, "date")
          };
        } else {
          columns = {
            data: e.title,
            renderer: customRenderer(state)
          };
        }
        break;
      default:
        columns = {
          data: e.title,
          renderer: customRenderer(state)
        };
        break;
    }
    if (e.read_only) columns.readOnly = true;
    tableColumns.push(columns);
  });
  return tableColumns;
};
// customColumnsRendeder - END
